import styled from '@emotion/styled'
import { Image } from 'components';

export default styled(Image)({
  borderRadius: '50%'
});
